import { Colors } from "@/enums/Colors";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import noEmail from "../../../../assets/images/no-email.svg";

type Props = {
  text?: string;
};

export const EmptyChatList = (props: Props) => {
  const { t } = useTranslation("chat");
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: Colors.ACCENT_F1F3FF,
        position: "relative",
        width: "100%",
        height: "100%",
        flexDirection: "column",
      }}
    >
      <img src={noEmail.src} alt="background" style={{ width: "10.563rem", height: "auto", zIndex: 1 }} />

      <Typography
        sx={{
          fontWeight: "600",
          fontSize: "0.875rem",
          lineHeight: "1.25rem",
          textAlign: "center",
          marginTop: "1.5rem",
          marginBottom: "0.75rem",
        }}
      >
        {props.text ? props.text : t("emptyChatList.noMessagesYet")}
      </Typography>
    </Box>
  );
};
